import React from 'react';
import { ResponsiveLine } from '@nivo/line';
import { metricLegend, competencyLegend, goalLegend } from '../_base';
import { useSelector } from 'react-redux';
import { SystemText } from '@salesperformanceint/e4shared';

const BarChart = ({ data, item }) => {
    const [percentile1, setPercentile1] = React.useState(true);
    const [percentile2, setPercentile2] = React.useState(true);
    const [legend1, setLegend1] = React.useState('Metric');
    const [legend2, setLegend2] = React.useState('Metric');
    const [xMax, setXMax] = React.useState(100);
    const [yMax, setYMax] = React.useState(100);

    const user = useSelector(state => state.user.user);
    const ratingRange = user.companySettings?.display?.ratingRange || 5;
    const goals = useSelector(state => state.dashboard.goals);
    const metrics = useSelector(state => state.dashboard.metrics);
    const competencies = useSelector(state => state.dashboard.competencies);

    const ofTarget = SystemText('Dashboard/Widgets/Matrix/OfTarget');

    const percentile = SystemText('Dashboard/Widgets/Matrix/Percentile');
    const rating = SystemText('Dashboard/Widgets/Matrix/Rating');

    React.useEffect(() => {
        if (item?.data) {
            const parsed = JSON.parse(item.data);
            parsed.type1 === 'C' && setLegend1(parsed.legend1 || competencyLegend(parsed.competency1, competencies));
            parsed.type1 === 'M' && setLegend1(parsed.legend1 || metricLegend(parsed.metric1, metrics, user.currencySymbol));
            parsed.type1 === 'G' && setLegend1(parsed.legend1 || `${goalLegend(parsed.goal1, goals)} ${ofTarget}`);
            setPercentile1(parsed.type1 !== 'G');
            parsed.type2 === 'C' && setLegend2(parsed.legend2 || competencyLegend(parsed.competency2, competencies));
            parsed.type2 === 'M' && setLegend2(parsed.legend2 || metricLegend(parsed.metric2, metrics, user.currencySymbol));
            parsed.type2 === 'G' && setLegend2(parsed.legend2 || `${goalLegend(parsed.goal2, goals)} ${ofTarget}`);
            setPercentile2(parsed.type2 !== 'G');
            setXMax(parsed.competencyTrueScale1 ? ratingRange : 100);
            setYMax(parsed.competencyTrueScale2 ? ratingRange : 100);
        }
    }, [item.data]);

    return (
        <>
            <div className="grid-cross">
                <div />
            </div>
            <ResponsiveLine
                data={[
                    {
                        id: 'grid',
                        data: [
                            { x: 0, y: 0 },
                            { x: 10, y: 10 },
                            { x: 20, y: 20 },
                            { x: 30, y: 30 },
                            { x: 40, y: 40 },
                            { x: 50, y: 50 },
                            { x: 60, y: 60 },
                            { x: 70, y: 70 },
                            { x: 80, y: 80 },
                            { x: 90, y: 90 },
                            { x: 100, y: 100 },
                        ].map(x => ({ x: (x.x * xMax) / 100, y: (x.y * yMax) / 100 })),
                    },
                ]}
                margin={{ top: 20, right: 20, bottom: 60, left: 60 }}
                padding={0.2}
                borderRadius={2}
                borderWidth={1}
                borderColor={{ from: 'color', modifiers: [['darker', '0.5']] }}
                minValue={0}
                maxValue={100}
                axisTop={null}
                axisBottom={{
                    tickValues: [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100].map(x => (x * xMax) / 100),
                    tickSize: 5,
                    tickPadding: 10,
                    tickRotation: 0,
                    legend: `${legend1} ${xMax === 5 ? rating : percentile1 ? percentile : ''}`,
                    legendPosition: 'middle',
                    legendOffset: 45,
                    maxValue: 100,
                    minValue: 0,
                }}
                axisLeft={{
                    tickValues: [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100].map(x => (x * yMax) / 100),
                    tickSize: 5,
                    tickPadding: 10,
                    tickRotation: 0,
                    legend: `${legend2} ${yMax === 5 ? rating : percentile2 ? percentile : ''}`,
                    legendPosition: 'middle',
                    legendOffset: -45,
                }}
                lineWidth={0}
                enablePoints={false}
                enableGridY
                enableGridX
                labelTextColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
                legends={[]}
            />
        </>
    );
};

export default BarChart;
